import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformNullValue'
})
export class TransformNullValuePipe implements PipeTransform {

  // 传入对象数组  和要转换的key
  transform(value: any): any {
    let isAllNull: boolean;

    // debugger;
    isAllNull = value.every(item => (item.value[2] === null || item.value[2] === '-'))


    for (const iterator of value) {

      if (isAllNull) {
        iterator.value[2] = iterator.value[2] === null ? -1 : (+iterator.value[2]).toFixed(1)
      } else {
        iterator.value[2] = iterator.value[2] === null ? '-' : (+iterator.value[2]).toFixed(1)
      }

    }
    return value
  }

}
